import ImportPicksLightBox from "../containers/import-picks-light-box";
import expandable from "./higher-order/expandable";
import pure from "./higher-order/pure";
import React from "react";

export default expandable(pure(function ImportPicksButton({ expanded, ticket, ticketsForRacesInCurrentTournament, toggle, tournament }) {

  if (ticketsForRacesInCurrentTournament.size === 0) {
    return "";
  }

  if (ticketsForRacesInCurrentTournament.size === 1 && ticketsForRacesInCurrentTournament.first().get("id") === ticket.get("id")) {
    return "";
  }

  if (tournament.get("lockdown") && tournament.get("status") !== "open") {
    return "";
  }

  var lightbox;

  if (expanded) {
    lightbox = (<ImportPicksLightBox onClose={toggle} ticket={ticket} tournament={tournament} />);
  }

  return (
    <div className="game-table_cell game-table_cell--ticket" key={ticket.get("id")}>
      <a
        className="game-table_import-picks tooltip js-behavior-toggle-lightbox"
        data-tooltip={"Import picks for Ticket #" + ticket.get("ticket_number")}
        onClick={toggle}>

        <i className="dw-share-alternative dw--1-25x" />

        <span className="text-small">
          Import Picks
        </span>
      </a>

      {lightbox}
    </div>
  );
}));
